import React, { ReactNode, useState } from 'react';
import { Container, Flex, Spacer } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import DepartmentModal from '../components/DepartmentModal';
import AnnounceModal from '../components/AnnounceModal';
import NavBar from './NavBar';
import Footer from './Footer';
/* 2026.04.03 初回ログイン時のスライド投稿誘導を非表示
import ImportantNoticeModal from './ImportantNoticeModal';
*/
// import OndemandProfileUpdateModal from './OndemandProfileUpdateModal';
import ProfileUpdateContainer from './ProfileUpdateContainer';
import AccountIntegrationContainer from './AccountIntegrationContainer';
import { PasswordAuthInduction } from './PasswordAuthInduction';
import { PromotionPopup } from './PromotionModal';

type Props = {
  children: ReactNode;
};

function Layout({ children }: Props) {
  const pathname = useRouter().pathname;
  const [promotionResolved, setPromotionResolved] = useState(false);
  // 特集ページ関係のみレイアウト調整
  const isSpecialPage = pathname.startsWith('/special');
  const isLoginPage = pathname === '/login';
  const isProfilePage = pathname.startsWith('/profile');
  const containerMaxWidth = pathname.startsWith('/article/view')
    ? { base: 'container.lg', '2xl': '95%' }
    : { base: 'container.lg' };

  let paddingProps;
  if (isSpecialPage) {
    paddingProps = { pt: 0, pl: 0, pr: 0 };
  } else if (isLoginPage) {
    paddingProps = {
      pt: [20, null, null, '6rem'],
      pl: ['initial', 'initial', 'initial'],
      pr: ['initial', 'initial', 'initial'],
    };
  } else {
    paddingProps = {
      pt: [24, null, isProfilePage ? 24 : 20, '7rem'],
      pl: ['initial', 'initial', 'initial'],
      pr: ['initial', 'initial', 'initial'],
    };
  }

  return (
    <Flex minH="100vh" direction="column" overflowX="hidden">
      <AnnounceModal />
      {/* 2026.04.03 初回ログイン時のスライド投稿誘導を非表示
      <ImportantNoticeModal />
      */}
      <PromotionPopup onResolved={() => setPromotionResolved(true)} />
      <DepartmentModal />
      {promotionResolved && (
        <>
          <AccountIntegrationContainer />
          <PasswordAuthInduction />
        </>
      )}
      {/* 2023.08.15 オンデマンドプロフィール更新誘導無効化
      <OndemandProfileUpdateModal />
      */}
      {/* TODO: プロフィール更新API呼び出し先切り替え */}
      {/* <ProfileUpdateContainer /> */}
      <NavBar />
      <Container {...paddingProps} pb={16} maxW={containerMaxWidth}>
        {children}
      </Container>
      <Spacer />
      <Footer />
    </Flex>
  );
}

export default Layout;
